/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AddExternalMCPForm = {
  /**
   * The display name for the external MCP server.
   */
  name: string;
  /**
   * The ID of the external MCP registry the server is from.
   */
  registryId?: string | undefined;
  /**
   * The canonical server name used to look up the server in the registry (e.g., 'slack', 'ai.exa/exa').
   */
  registryServerSpecifier: string;
  /**
   * URLs of the remotes to use for this MCP server. If not provided, the backend will auto-select based on transport type preference.
   */
  selectedRemotes?: Array<string> | undefined;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug: string;
};

/** @internal */
export type AddExternalMCPForm$Outbound = {
  name: string;
  registry_id?: string | undefined;
  registry_server_specifier: string;
  selected_remotes?: Array<string> | undefined;
  slug: string;
};

/** @internal */
export const AddExternalMCPForm$outboundSchema: z.ZodMiniType<
  AddExternalMCPForm$Outbound,
  AddExternalMCPForm
> = z.pipe(
  z.object({
    name: z.string(),
    registryId: z.optional(z.string()),
    registryServerSpecifier: z.string(),
    selectedRemotes: z.optional(z.array(z.string())),
    slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      registryId: "registry_id",
      registryServerSpecifier: "registry_server_specifier",
      selectedRemotes: "selected_remotes",
    });
  }),
);

export function addExternalMCPFormToJSON(
  addExternalMCPForm: AddExternalMCPForm,
): string {
  return JSON.stringify(
    AddExternalMCPForm$outboundSchema.parse(addExternalMCPForm),
  );
}
